/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, inject, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { NewCustomRouteService } from '../../../../new-custom-route.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SIZE_CARDS } from '../../../../constants';
import Swal from "sweetalert2";
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'timeline-card',
  imports: [CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './card-timeline.component.html',
  styleUrls: ['./card-timeline.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CardTimeLineComponent {
    private routeService = inject(NewCustomRouteService);
    public tools = inject(ToolsService);
    public translate = inject(TranslateService)
    public item: InputSignal<any> = input.required<any>();
    public color: InputSignal<any> = input<any>();

    public marginSizeCards = SIZE_CARDS;

    showItemInfo(item){
      if (!item?.id) return;
      this.routeService.modalItemInfo(item, true);
    }

    removeItem(item) {
      Swal.fire({
        title: this.translate.instant(`¿Quieres eliminar`) + ' ' + item?.point?.name?.[this.translate.currentLang] + ' ' + this.translate.instant('de la ruta?'),
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonColor: "#ff0000",
        cancelButtonColor: "#000000",
        confirmButtonText: this.translate.instant("Eliminar"),
        cancelButtonText: this.translate.instant(`Cancelar`),
        reverseButtons: true,
        scrollbarPadding: false
      }).then((result) => {
        if (result.isConfirmed) 
          this.routeService.removeItem(item.point)
      });
    }


}